const footerCta = document.querySelectorAll('.js-footer')
footerCta.forEach(function (elem) {
  elem.addEventListener('click', function () {
    elem.parentElement.classList.toggle('active')
  })
})
